import Card from "@mui/material/Card";
import Dialog, { DialogProps } from "@mui/material/Dialog";

export type ModalProps = Omit<DialogProps, "onClose"> & {
  onClose?: (
    event: {},
    reason?: "backdropClick" | "escapeKeyDown" | "buttonClick"
  ) => void;
};

/**
 * @deprecated
 * Use the Modal from webapp/src/analytics/components/Modal.tsx
 */
const Modal = ({ sx, ...props }: DialogProps) => {
  return (
    <Dialog {...props}>
      <Card
        sx={{
          maxHeight: "95%",
          minWidth: { xxs: "auto", mobile: "600px" },
          py: "20px",
          px: "24px",
          ...sx,
        }}
      >
        {props.children}
      </Card>
    </Dialog>
  );
};

export default Modal;
